module.exports = __webpack_public_path__ + "static/media/football-min.79408b48.jpg";